import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const upsertEmailTemplate = (request) => {
    const formData = new FormData();
    formData.append('EventId', request.eventId);
    formData.append('LanguageId', request.languageId);
    formData.append('TemplateType', String(request.templateType));
    formData.append('Status', String(request.status ?? 1));
    formData.append('IsActive', String(request.isActive ?? true));
    formData.append('ShowHeaderImage', String(request.showHeaderImage));
    formData.append('ShowFeatureImage', String(request.showFeatureImage));
    formData.append('Name', request.name ?? '');
    formData.append('SubjectTemplate', request.subjectTemplate ?? '');
    formData.append('BodyTemplateHtml', request.bodyTemplateHtml ?? '');
    request.images?.forEach((image, index) => {
        formData.append(`Images[${index}].ImageRole`, String(image.imageRole));
        formData.append(`Images[${index}].SortOrder`, String(image.sortOrder));
        formData.append(`Images[${index}].IsActive`, String(image.isActive ?? true));
        formData.append(`Images[${index}].Name`, image.name ?? '');
        formData.append(`Images[${index}].FolderName`, image.folderName ?? '');
        formData.append(`Images[${index}].FileSize`, image.fileSize ?? '');
        formData.append(`Images[${index}].Url`, image.url ?? '');
        formData.append(`Images[${index}].FileTitle`, image.fileTitle ?? '');
        formData.append(`Images[${index}].AltText`, image.altText ?? '');
        if (image.image) {
            formData.append(`Images[${index}].Image`, image.image);
        }
    });
    return vdkEmHappinessPortalApi.post('/emailtemplates/upsert', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
const getEmailTemplatesByEventId = (eventId) => {
    return vdkEmHappinessPortalApi.get(`/emailtemplates/event/${eventId}`);
};
const getEmailTemplateById = (id) => {
    return vdkEmHappinessPortalApi.get(`/emailtemplates/${id}`);
};
const getEmailTemplateByContext = (request) => {
    return vdkEmHappinessPortalApi.post(`/emailtemplates/by-context`, {
        eventId: request.eventId,
        languageId: request.languageId,
        templateType: request.templateType
    });
};
const getEventEmailTemplates = (request) => {
    return vdkEmHappinessPortalApi.get(`/emailtemplates/event/${request.eventId}`);
};
const toggleEmailTemplatesByEventAndType = (request) => {
    return vdkEmHappinessPortalApi.get(`/emailtemplates/event/${request.eventId}/type/${request.templateType}/toggle-active?isActive=${request.isActive}`);
};
const createDefaultEmailTemplates = (request) => {
    const formData = new FormData();
    formData.append('EventId', request.eventId);
    request.templates.forEach((template, index) => {
        formData.append(`Templates[${index}].LanguageId`, template.languageId);
        formData.append(`Templates[${index}].Type`, String(template.type));
        formData.append(`Templates[${index}].IsActive`, String(template.isActive));
        formData.append(`Templates[${index}].ShowHeaderImage`, String(template.showHeaderImage));
        formData.append(`Templates[${index}].ShowFeatureImage`, String(template.showFeatureImage));
        formData.append(`Templates[${index}].Name`, template.name);
        formData.append(`Templates[${index}].SubjectTemplate`, template.subjectTemplate);
        formData.append(`Templates[${index}].BodyHtmlTemplate`, template.bodyHtmlTemplate);
        formData.append(`Templates[${index}].Status`, String(template.status));
    });
    return vdkEmHappinessPortalApi.post('/emailtemplates/create-default', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
const EmailTemplatesApi = {
    upsertEmailTemplate,
    getEmailTemplatesByEventId,
    getEmailTemplateById,
    getEmailTemplateByContext,
    getEventEmailTemplates,
    toggleEmailTemplatesByEventAndType,
    createDefaultEmailTemplates
};
export default EmailTemplatesApi;
